<template>
	<div>
		<div class="item">
			<!--参考图-->
			<canvas id="referenceImage_canvas1" v-bind:width="width" v-bind:height="height" tabindex="1" />
		</div>
		<div class="item">
			<!--缺陷图(左键切换参考图)-->
			<canvas id="referenceImage_canvas2" v-bind:width="width" v-bind:height="height" @mousedown="mousedown" @mouseup="mouseup" tabindex="2" />
		</div>
	</div>
</template>

<script>
	import { store } from './store'
	export default {
		data() {
			return {
				width: (document.body.clientHeight - 370) / 2,
				height: (document.body.clientHeight - 370) / 2,
				canvas1: null,
				canvas2: null,
				image1: '',
				image2: '',
			}
		},
		computed: {
			/**
			 * 选中的缺陷记录Id。
			 */
			selectedDefectId() {
				return store.state.selectedDefectId
			},
			/**
			 * 选中缺陷记录对应版图中的抠图。
			 */
			defectCutoutImage() {
				return store.state.defectCutoutImage
			},
		},
		watch: {
			/**
			 * 监控选中的缺陷记录，实时绘制缺陷图。
			 */
			async selectedDefectId(val) {
				if (val) {
					var defectImage = await store.getDefectImage(val)
					this.image2 = defectImage

					//绘制缺陷图。
					if (this.canvas2) {
						this.drawImage(this.canvas2, defectImage)
					}
				}
			},
			/**
			 * 监控选中缺陷记录对应版图的抠图，实时绘制版图中的抠图。
			 */
			defectCutoutImage(dataUrl) {
				this.image1 = dataUrl

				//绘制抠图。
				if (!this.canvas1) return
				this.drawImage(this.canvas1, dataUrl)
			},
		},
		methods: {
			/**
			 * 缺陷图鼠标按下之后，显示参考图。
			 */
			mousedown() {
				this.drawImage(this.canvas2, this.image1)
			},
			/**
			 * 缺陷图鼠标释放后，恢复显示缺陷图。
			 */
			mouseup() {
				this.drawImage(this.canvas2, this.image2)
			},
			/**
			 * 绘制图片。
			 */
			drawImage(cav, imgDataUri) {
				var cxt = cav.getContext('2d')
				cxt.clearRect(0, 0, this.width, this.height)

				var image = new Image()
				image.src = imgDataUri
				image.onload = () => {
					cxt.drawImage(image, 0, 0, this.width, this.height)

					this.drawDefectRect()
				}
			},
			/**
			 * 绘制缺陷矩形框。
			 */
			drawDefectRect() {
				//选中缺陷记录
				var defectInfo = store.getDefectInfo(this.selectedDefectId)
				var defectSize = [defectInfo.size_cx, defectInfo.size_cy]

				var x = this.canvas2.width / 2 - defectSize[0] / 2
				var y = this.canvas2.height / 2 - defectSize[1] / 2

				if (isNaN(x) || isNaN(y)) return

				var ctx = this.canvas2.getContext('2d')
				ctx.strokeStyle = '#f00'
				ctx.strokeRect(x, y, defectSize[0], defectSize[1])
			},
		},
		mounted() {
			this.canvas1 = document.getElementById('referenceImage_canvas1')
			this.canvas2 = document.getElementById('referenceImage_canvas2')
		},
	}
</script>

<style lang="less" scoped>
	.item {
		user-select: none;
		height: 285px;
		canvas {
			background-color: #333;
			border: 1px #7d7d7d dotted;
		}
	}
</style>
